import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";

import store from "@/store";
import Home from "@/views/Home.vue";
import Callback from "@/views/Callback.vue";
import VersionUpdate from "@/views/VersionUpdate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    name: "404",
    component: () => import("@/views/404.vue"),
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Page Not Found",
    },
  },
  {
    path: "/403",
    name: "403",
    component: () => import("@/views/403.vue"),
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "UnAuthorized Page",
    },
  },
  {
    path: "/callback",
    name: "Callback",
    component: Callback,
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Authenticating User",
    },
  },

  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      secured: false,
      saveToLast: false,
      layout: "centered-layout",
      title: "Parked(TM) Admins",
    },
  },

  {
    path: "/pwa-update",
    name: "VersionUpdate",
    components: {
      default: VersionUpdate,
    },
    meta: {
      secured: false,
      layout: "centered-layout",
      title: "Version Update.",
    },
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Dashboard",
    },
  },
  {
    path: "/rewards",
    name: "Rewards",
    component: () => import("@/views/Rewards.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Rewards",
    },
  },

  // {
  //   path: "/activated",
  //   name: "ActivatedParticipants",
  //   component: () => import("@/views/Activated.vue"),
  //   meta: {
  //     secured: true,
  //     saveToLast: true,
  //     layout: "default-layout",
  //     title: "Active Participants",
  //   }
  // },

  // {
  //   path: "/confirmed",
  //   name: "ConfirmedParticipants",
  //   component: () => import("@/views/Confirmed.vue"),
  //   meta: {
  //     secured: true,
  //     saveToLast: true,
  //     layout: "default-layout",
  //     title: "Confirmed Participants",
  //   }
  // },

  {
    path: "/surveys",
    name: "Surveys",
    component: () => import("@/views/Surveys.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Surveys",
    },
  },

  // {
  //   path: "/no-match",
  //   name: "NoMatchParticipants",
  //   component: () => import("@/views/NoMatch.vue"),
  //   meta: {
  //     secured: true,
  //     saveToLast: true,
  //     layout: "default-layout",
  //     title: "Unmatched Participants",
  //   }
  // },

  {
    path: "/participants/:id",
    name: "Participant",
    component: () => import("@/views/Participant.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Participant",
    },
  },

  {
    path: "/insurance/participants/:id",
    name: "Participant",
    component: () => import("@/views/InsuranceProfileParticipant.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Participant",
    },
  },

  {
    path: "/survey/:id",
    name: "Survey",
    component: () => import("@/views/SurveyDetail.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Survey",
    },
  },

  {
    path: "/properties",
    name: "Properties",
    component: () => import("@/views/Properties.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Properties",
    },
  },

  {
    path: "/policies",
    name: "Policies",
    component: () => import("@/views/PolicyCheckins.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Policies",
    },
  },

  {
    path: "/policy-checkins/:id",
    name: "Policies",
    component: () => import("@/views/PolicyCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Policies",
    },
  },

  {
    path: "/property-checkin/:id",
    name: "PropertyCheckin",
    component: () => import("@/views/PropertyCheckin.vue"),
    meta: {
      secured: true,
      saveToLast: true,
      layout: "default-layout",
      title: "Property Checkin",
    },
  },

  // {
  //   path: "/access",
  //   name: "Access",
  //   component: () => import("@/views/Access.vue"),
  //   meta: {
  //     secured: true,
  //     saveToLast: true,
  //     layout: "default-layout",
  //     title: "Access",
  //   }
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
});

router.beforeResolve((to, from, next) => {
  const title = to.meta && to.meta.title ? to.meta.title : to.name;
  document.title = title;

  //console.log("router.beforeResolve:", to);

  if (to.meta && to.meta.secured) {
    const authenticated = store.getters["auth/authenticated"];
    const authorized = store.getters["auth/authorized"];
    if (authenticated && authorized) {
      next();
    } else {
      if (to.meta && to.meta.saveToLast) {
        const saved_route_data = {
          path: to.path,
          params: to.params,
          query: to.query,
        };
        localStorage.setItem("route_to", JSON.stringify(saved_route_data));
      }

      next({
        name: "403",
      });
    }
  } else {
    next();
  }
});

export default router;
